import { WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSIONS_TABLE } from '../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { getTableColumns } from './grid-config';
import { html, TemplateResult } from 'lit';
import { GRID_ITEM_FORM_ID } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/base/component/GzPolicyUiSettingsBaseGrid';
import { FirewallExclusionItem } from '@nirvana/shared/dtos/types/policies/common';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { validateDuplicates } from '../utils/validators';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../../../../ui/gzCheckbox';
import {
  NetworkProtectionApiClients,
  PolicyDependenciesContainer,
} from '../../../../../../common/policyPanel/uiSettings/dependencies/PolicyDependenciesContainer';
import { TextHighlightMixin } from '../../../../../../../mixins';
import { connect } from 'pwa-helpers';
import { RootState, store } from '@nirvana/redux/store';
import { selectAccordionsSearchState } from '@nirvana/redux/searchable-ui-accordions';
import { getFirewallSettingsSearchableKeywords } from '../../../../utils/uiSettings/firewall/firewall.values';
import { FirewallSettingsSearchableKeywords } from '../../../../utils/uiSettings/firewall/firewall.types';
import { PolicyPanelManager } from '../../../../PolicyPanelManager';

class GzFirewallSettingsExclusionsTableWebComponent extends GzPolicyUiSettingsTableWebComponent<
  FirewallExclusionItem,
  FirewallExclusionItem
> {
  protected searchableKeywords = getFirewallSettingsSearchableKeywords();
  protected hasReorderRowAction = false;
  protected columns = getTableColumns();
  protected clients = PolicyDependenciesContainer.getInstance().resolveDependency(
    'NetworkProtection'
  ) as NetworkProtectionApiClients;

  @query('#duplicate-field')
  private duplicateFormField: GzFormFieldWebComponent<GzCheckboxWebComponent, boolean>;

  protected renderGridItemForm(): TemplateResult {
    return html`
      <gz-policy-panel-firewall-settings-exclusion-item
        id="${GRID_ITEM_FORM_ID}"
      ></gz-policy-panel-firewall-settings-exclusion-item>

      <gz-form-field style="padding-top: 10px" id="duplicate-field">
        <gz-checkbox
          searchable-label="${this.searchableKeywords[FirewallSettingsSearchableKeywords.Duplicate].label}"
          label="${this.searchableKeywords[FirewallSettingsSearchableKeywords.Duplicate].translatedLabel}"
          gz-form-input
        ></gz-checkbox>
        <gz-text fontSize="12" fontWeight="400" class="form-field-info-text"
          >${translateFn('Recommended when vulnerability scanners are excluded.')} <br />
          ${translateFn('Applicable to Network Protection exclusions, provided they are enabled.')}
        </gz-text>
      </gz-form-field>
    `;
  }

  protected validateGridItemBeforeAdd(gridItemFormValue: FirewallExclusionItem): ValidationResult {
    // check for duplicates
    return validateDuplicates(gridItemFormValue, this.gridComponent.getFormValue());
  }

  protected onNewGridItemAdd(item: FirewallExclusionItem, position?: number): ValidationResult {
    const validationResult = super.onNewGridItemAdd(item, position);

    // skip if validation failed
    if (!validationResult.valid) {
      return validationResult;
    }

    // duplicate item to Network Protection grid
    if (this.duplicateFormField.value) {
      PolicyPanelManager.getInstance().duplicateExclusionItemToContentControl(item);
    }

    return validationResult;
  }

  protected validateGridItemBeforeEdit(
    oldItem: FirewallExclusionItem,
    newItem: FirewallExclusionItem
  ): ValidationResult {
    // skip if item is not changed
    if (newItem.ip === oldItem.ip) {
      return { valid: true };
    }

    return this.validateGridItemBeforeAdd(newItem);
  }
}

/**
 * This wrapper is necessary to connect the web component to the store.
 */
@customElement(WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSIONS_TABLE)
export class GzFirewallSettingsExclusionsTableWrapperWebComponent extends TextHighlightMixin(
  connect(store)(GzFirewallSettingsExclusionsTableWebComponent)
) {
  /**
   * State changed, update search string.
   * @param rootState
   */
  public stateChanged(rootState: RootState) {
    const accordionsSearchApp = selectAccordionsSearchState(rootState);
    this.searchString = accordionsSearchApp.searchString;
  }
}
